import { render, staticRenderFns } from "./esqueci-senha.vue?vue&type=template&id=cc610fe2&"
import script from "./esqueci-senha.vue?vue&type=script&lang=js&"
export * from "./esqueci-senha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports